<template>
    <div :class="`question-frame ${mode}`">
        <div class="question-main-img" v-show="image" @click="imageViewerHandler">
            <img :src="image" title="이미지" />
        </div>
        <div class="question-title">
            <div class="question-title__text">
                <div class="title" v-html="_title(title)"></div>
            </div>
            <div class="question-title__require">
                {{get_question_options}}
            </div>
        </div>
        <div class="question-content">
            <answer-component
                :mode="mode"
                :no="no"
                :parentNo="parentNo"
                :answer="answer"
                :status="status"
                :type="type"
                :value="value"
                :isInput="isInput"
                :firstComeByAnswer="firstComeByAnswer"
                :countOfChoices="countOfChoices"
                :onChange="onChange"
                :onEtcChange="onEtcChange"
                :onError="onError"
                @signature="signatureModal"
                @upload="data => $emit('upload', data)"
                @clear-upload="data => $emit('clear-upload', data)"
            />
        </div>

        <div class="sub-area" v-if="mode === 'main'">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

import { nl2br, tranceferUnicode } from "../lib/core";

import SingleSelector from "@/components/SingleSelector";
import MultiSelector from "@/components/MultiSelector";
import ShortSentence from "@/components/ShortSentence";
import LongSentence from "@/components/LongSentence";
import SignatureBox from "@/components/SignatureBox";
import ImageUploader from "@/components/ImageUploader";

const components = [SingleSelector, MultiSelector, ShortSentence, LongSentence, SignatureBox, ImageUploader];

Vue.component("answer-component", {
    render(createElement) {
        const slot = this.$slots.default;

        const { answer, type, no, mode, status, parentNo, value, isInput, onChange, onEtcChange, countOfChoices, onError, firstComeByAnswer } = this;

        const template = components[type - 1];

        return createElement(template, {
            slot,
            props: {
                answer,
                type,
                no,
                mode,
                status,
                parentNo,
                value,
                isInput,
                firstComeByAnswer,
                onChange,
                onEtcChange,
                countOfChoices,
                onSignature: data => this.$emit("signature", data),
                onUpload: data => this.$emit("upload", data),
                onClearUpload: data => this.$emit("clear-upload", data),
                onError,
            }
        });
    },
    props: {
        answer: Array,
        type: Number,
        no: Number,
        mode: String,
        status: String,
        parentNo: Number,
        value: Array,
        isInput: Boolean,
        firstComeByAnswer: Boolean,
        onChange: Function,
        onEtcChange: Function,
        countOfChoices: Number,
        onError: Function,
    }
});

export default {
    name: "QuestionFrame",
    props: {
        mode: String,
        type: Number,
        no: Number,
        parentNo: Number,
        title: String,
        status: String,
        image: String,
        answer: Array,
        isInput: Boolean,
        firstComeByAnswer: Boolean,
        countOfChoices: Number,
        value: Array,
        onChange: Function,
        onEtcChange: Function,
        onError: Function,
    },
    computed: {
        no_plus() {
            if (this.mode === "sub") {
                return `${this.parentNo + 1}-${this.no + 1}`;
            }

            return this.no + 1;
        },
        _title() {
            return title => {
                let no = this.mode === "sub" ? `${this.parentNo + 1}-${this.no + 1}` : this.no + 1;

                const transefer = tranceferUnicode(title);
                const html = nl2br(transefer);
                return `<span class='no'>${no}.</span> ${html}`;
            };
        },
        get_question_options() {
            let options = [];
            if(this.isInput) {
                options.push("필수 질문");
            }
            if(this.countOfChoices && this.countOfChoices !== 0) {
                options.push("최대 " + this.countOfChoices + "개 선택");
            }
            if(this.firstComeByAnswer) {
                options.push("보기별 선착순");
            }
            return options.join(", ");
        }
    },
    methods: {
        signatureModal(data) {
            this.$emit("signature", data);
        },

        imageViewerHandler() {
            this.$emit("url", this.image);
            this.$emit("modal");
        }
    }
};
</script>

<style lang="scss" src="../styles/_question.scss" />
